import React, { memo, useContext } from "react";
import PendingTableCell from "./PendingTableCell";
import { ChemBioPendingContext } from "../../ChemBioPendingContext";

const PendingTableRow = ({ data }) => {
  const { getTargetColumns } = useContext(ChemBioPendingContext);

  const targetCols = getTargetColumns();

  return (
    <tr>
      {targetCols.map((item, i) => (
        <PendingTableCell key={i} data={data} cellItem={item} />
      ))}
    </tr>
  );
};

export default memo(PendingTableRow);
